export function mod(n: number, d: number) {
    return ((n % d) + d) % d;
}
